import React from 'react';
import { Form, FormGroup, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import './style.scss'

class HelperBox extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <Form vertical className="form" autoComplete="off" onSubmit={evt => { evt.preventDefault(); }}>
                <Col lg={12} fluid="xs">
                        <FormGroup>
                            <InputGroup bsSize="sm" className="input-group">
                                <InputGroup.Addon className="input-addon">Active grade</InputGroup.Addon>
                                <FormControl
                                    bsSize="sm"
                                    readOnly={true}
                                    value={this.props.activeGrade}
                                    className="control-format"
                                />
                            </InputGroup>
                            <InputGroup bsSize="sm">
                                <InputGroup.Addon className="input-addon">Grade handling</InputGroup.Addon>
                                <FormControl
                                    bsSize="sm"
                                    readOnly={true}
                                    value={this.props.gradeHandling}
                                    className="control-format"
                                />
                            </InputGroup>    
                        </FormGroup>
                        <FormGroup>
                            <InputGroup bsSize="sm">
                                <InputGroup.Addon className="input-addon">Min {this.props.gradeHandling.toLowerCase()}</InputGroup.Addon>
                                <FormControl
                                    bsSize="sm"
                                    readOnly={true}
                                    value={this.props.minGrammage}
                                    className="control-format"
                                />
                            </InputGroup>
                            <InputGroup bsSize="sm">
                                <InputGroup.Addon className="input-addon">Max {this.props.gradeHandling.toLowerCase()}</InputGroup.Addon>
                                <FormControl
                                    bsSize="sm"
                                    readOnly={true}
                                    value={this.props.maxGrammage}
                                    className="control-format"
                                />
                            </InputGroup>
                        </FormGroup>
                </Col>
            </Form>
        )
    }
}

export default HelperBox;